// extracted by mini-css-extract-plugin
export default {"lightBlue":"1px solid #a1cfdb","normalBlack":"1px solid #00263a"};